export default __webpack_public_path__ + "static/media/image-faceit.ed52b7a3.jpg";